<template>
    <div class="content">
    <div class="container-fluid" v-if="loading">
        <div class="row">
            <div class="col-xl-12">
                <h2>Loading...</h2>
            </div>
        </div>
    </div>
    <div class="container-fluid" v-if="!loading">
            <div class="row" v-if="!loading">
                <div class="col-md-6" v-for="(cost_data, index) in costs_data">
                    <chart-card :key='cost_data' :chart-data="cost_data.data"
                                :chart-options="cost_data.options"
                                :responsive-options="cost_data.responsiveOptions"
                                chart-type="Bar"
                    >
                        <template slot="header">
                            <h4 class="card-title">Costs Breakdown for {{index}} (Gitlab only)</h4>
                            <p class="card-category">Values in $</p>
                        </template>
                        <template slot="footer">
                            <div class="legend">
                                <i class="fa fa-circle" :style='{color: colors[0]}'></i> AWS GitLab Costs
                                <i class="fa fa-circle" :style='{color: colors[1]}'></i> GitLab License
                                <i class="fa fa-circle" :style='{color: colors[2]}'></i> Edrans Support
                            </div>
                        </template>
                    </chart-card>
                </div>
            </div>
            </div>
    </div>
</template>

<script>
    import ChartCard from 'src/components/Cards/ChartCard.vue'
    import StatsCard from 'src/components/Cards/StatsCard.vue'
    import LTable from 'src/components/Table.vue'
    import axios from 'axios'
    import { colors, formatMoney, formatSimple } from 'src/globalVariables'
    export default {
        name: 'organization',
        props: {
            org: '',
        },

        components: {
            LTable,
            ChartCard,
            StatsCard
        },
        async created() {
            this.accessToken = await this.$auth.getAccessToken()
            this.loadData();
        },
        methods: {
            loadData: function () {
                axios.all([
                    axios.get('gitlab/costs?access_token=' + this.accessToken),
                    axios.get('invoices/current-data?access_token=' + this.accessToken+'&vendor_name=GitLab_License&st_date=201901&fn_date=201912'),
                    axios.get('invoices/current-data?access_token=' + this.accessToken+'&vendor_name=GitLab_Support&st_date=201908&fn_date=201912'),
                    axios.get('gitlab/users?access_token=' + this.accessToken)
                ]).then(axios.spread((first, second, third, fourth) => {
                    this.costs_infra = first.data.results;
                    this.costs_license = second.data;
                    this.costs_support = third.data;
                    this.users = fourth.data;
                    this.$nextTick(function () {
                        this.loading = false
                    })
                }));
            },
            get_costs: function(org, unit = false) {
                if (typeof this.users != 'undefined') {
                    let [labels, series1, series2, series3] = [[], [], [], []];
                    let totals = [0, 0, 0];
                    let totalUsers = this.users.count;
                    let userCount, orgUnit;

                    if (unit == false) {
                        userCount = this.users.totals[org];
                        orgUnit = org;
                    } else {
                        userCount = this.users.entity[org][unit]
                        orgUnit = unit
                    }
                    let userMultiplier = userCount/totalUsers;

                    let license_cost = (this.costs_license[0]['cost']/12) * userMultiplier;
                    if (typeof this.costs_infra != 'undefined') {
                        this.costs_infra.forEach(function(v, i){
                            labels.push(v['year_month']);
                            series1.push(parseFloat(v['unblended_cost'].substring(1).replace(',','')) * userMultiplier);
                            series2.push(license_cost);
                            totals[i] += series1[i] + series2[i];
                        });
                    }
                    this.costs_support.forEach(function(v, i){
                        series3[i] = v['cost'] * userMultiplier;
                        totals[i] += series3[i];
                    });

                    let series = [series1, series2, series3];
                    this.costs_data[orgUnit] = {
                        'data': {
                            'labels': labels,
                            'series': series
                        },
                        'options': {
                            'stackBars': true,
                            'seriesBarWidth': 50,
                            'seriesBarDistance': 50,
                            'axisX': {
                                'showGrid': true
                            },
                            'height': '245px',
                            'chartPadding': {
                                'right': 50,
                                'left': 50,
                            },
                            'tooltip':{
                                'tooltipFnc': function(meta, value){
                                    return(value)
                                },

                                tooltipOffset: {
                                    x: 15,
                                    y: 90
                                },
                                'appendToBody':false,
                                'transformTooltipTextFnc': function(value) {
                                    return ''+ formatMoney.format(value)
                                }
                            },
                        },
                        'responsiveOptions': [
                            ['screen and (max-width: 640px)', {
                                'seriesBarDistance': 6,
                                'axisX': {
                                    labelInterpolationFnc (value) {
                                        return value[0]
                                    }
                                }
                            }]
                        ]
                    }

                    if (unit == false) {
                        for (unit in this.users.entity[org]) {
                            this.get_costs(this.org, unit)
                        }
                    }
                }
            }
        },
        watch: {
            loading:function(){
                this.get_costs(this.$props.org)
            },
        },
        data: function () {
            return {
                colors: colors,
                costs_infra: {},
                costs_license: {},
                costs_support: {},
                costs_data: {},
                users: {},
                editTooltip: 'Edit Task',
                deleteTooltip: 'Remove',
                // org: "CENTRAL",
                loading: true
            }
        }
    }
</script>